/* Dansk katalog for locale-no.js (del 4 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'adv.sales.move.chaseSlowPayers.effectLbl': 'Mulig reduktion i kredittid',
  'adv.sales.move.chaseSlowPayers.effectNote': 'ned mod dit eget gennemsnit — kroneeffekten afhænger af, hvornår kunden faktisk betaler',
  'adv.sales.move.chaseSlowPayers.action': 'Se fakturalisten',
  'adv.sales.move.reviewDiscounts.title': 'Gennemgå rabatterne',
  'adv.sales.move.reviewDiscounts.text': 'Du har givet {amount} i rabat i år, i gennemsnit {pct} % pr. faktura.',
  'adv.sales.move.reviewDiscounts.effectLbl': 'Anslået effekt',
  'adv.sales.move.reviewDiscounts.effectNote': 'ved at halvere rabatniveauet',
  'adv.sales.move.reviewDiscounts.action': 'Se fakturalisten',
  'adv.sales.move.spreadCustomers.title': 'Spred kundebasen',
  'adv.sales.move.spreadCustomers.text': '{name} står for {pct} % af salget. Én kunde bør ikke bære omsætningen alene.',
  'adv.sales.move.spreadCustomers.effectLbl': 'Andel fra største kunde',
  'adv.sales.move.spreadCustomers.effectNote': 'dette er risikoen, ikke en gevinst',
  'adv.sales.move.spreadCustomers.action': 'Se kunder',
  'adv.sales.move.testPriceIncrease.title': 'Overvej en prisstigning',
  'adv.sales.move.testPriceIncrease.text': 'Test, hvad {pct} % højere pris gør ved omsætningen, før du beslutter dig.',
  'adv.sales.move.testPriceIncrease.effectLbl': 'Anslået årlig effekt',
  'adv.sales.move.testPriceIncrease.effectNote': 'med dagens volumen',
  'adv.sales.move.testPriceIncrease.action': 'Se produkter',
  'adv.sales.move.growRecurring.title': 'Byg mere tilbagevendende salg',
  'adv.sales.move.growRecurring.text': '{pct} % af salget er tilbagevendende. Kommer du op mod {target} %, bliver omsætningen langt mere forudsigelig.',
  'adv.sales.move.growRecurring.effectLbl': 'Omsætning, der kan blive forudsigelig',
  'adv.sales.move.growRecurring.effectNote': 'hvis andelen når målet',
  'adv.sales.move.growRecurring.action': 'Se abonnementer',
  'adv.sales.scn.title': 'Salgsscenarier — Hvad sker der, hvis …',
  'adv.sales.scn.sub': 'Effekt på omsætning, resultat og likviditet',
  'adv.sales.scn.help': 'Vælg et scenarie for at se før/efter på omsætning, resultat, margin og likviditet sammen med de forudsætninger, jeg har lagt til grund. Tallene er beregninger, ikke garantier.',
  'adv.sales.scn.metric': 'Nøgletal',
  'adv.sales.scn.base': 'Basis',
  'adv.sales.scn.after': 'Efter scenarie',
  'adv.sales.scn.change': 'Ændring',
  'adv.sales.scn.row.revenue': 'Omsætning',
  'adv.sales.scn.row.result': 'Resultat',
  'adv.sales.scn.row.margin': 'Resultatmargin',
  'adv.sales.scn.row.liquidity': 'Beregnet plansaldo',
  'adv.sales.scn.points': '{points} pct.-point',
  'adv.sales.scn.assumptions': 'Forudsætninger',
  'adv.sales.scn.showAssumptions': 'Vis forudsætninger',
  'adv.sales.scn.confidence': 'Sikkerhed',
  'adv.sales.scn.risk': 'Risiko',
  'adv.sales.scn.scope': 'Omfang',
  'adv.sales.scn.q.priceUp': 'Jeg hæver priserne',
  'adv.sales.scn.q.volumeDown': 'Salgsvolumen falder',
  'adv.sales.scn.q.halveDiscounts': 'Jeg fjerner halvdelen af rabatterne',
  'adv.sales.scn.q.loseTopCustomer': 'Jeg mister {name}',
  'adv.sales.scn.q.growRecurring': 'Tilbagevendende salg stiger {pct} %',
  'adv.sales.scn.summary.priceUp': 'Med dagens volumen giver {pct} % prisstigning omkring {delta} mere i årlig omsætning. En prisstigning giver ingen ekstra vare- eller timeomkostning, så hele beløbet slår igennem på resultatet.',
  'adv.sales.scn.summary.volumeDown': 'Et volumenfald på {pct} % tager omkring {delta} ud af omsætningen. Beregningen forudsætter, at omkostningerne står stille, så dette er det strengeste udfald — falder varekøbene med volumen, bliver effekten mindre.',
  'adv.sales.scn.summary.halveDiscounts': 'Du har givet {amount} i rabat i år, i gennemsnit {pct} %. Halverer du niveauet, henter du omkring {delta} — forudsat at kunderne bliver.',
  'adv.sales.scn.summary.loseTopCustomer': 'Falder {name} fra, mister du {delta} — {pct} % af salget. Det er tallet, der gør kundespredning værd at tage fat på, før det sker.',
  'adv.sales.scn.summary.growRecurring': 'Stiger det tilbagevendende salg {pct} %, giver det omkring {delta} mere om året. Tilbagevendende indtægt er den mest forudsigelige omsætning, du har.',
  'adv.sales.scn.assumption.priceUp': 'Volumen holder sig. Gælder alle produkter og tjenester.',
  'adv.sales.scn.assumption.volumeDown': 'Omkostningerne står stille. Plumme har ingen kostpris pr. produkt, så jeg kan ikke beregne, hvor meget af omkostningen der falder med volumen.',
  'adv.sales.scn.assumption.halveDiscounts': 'Kunderne køber lige så meget med lavere rabat. Beregnet ud fra den faktisk givne rabat i år.',
  'adv.sales.scn.assumption.loseTopCustomer': 'Ingen del af omsætningen erstattes af andre kunder. Beregnet ud fra kundens faktiske bogførte salg.',
  'adv.sales.scn.assumption.growRecurring': 'Væksten kommer oven i det nuværende salg, ikke i stedet for.',
  'adv.sales.scn.riskText.priceUp': 'Falder volumen mere end prisstigningen, forsvinder effekten. Følg salgsvolumen de første to måneder.',
  'adv.sales.scn.riskText.volumeDown': 'Falder volumen hos de mest rentable kunder først, bliver effekten større end dette.',
  'adv.sales.scn.riskText.halveDiscounts': 'Kunder, der køber på grund af rabatten, kan falde fra. Test på nogle få først.',
  'adv.sales.scn.riskText.loseTopCustomer': 'Faste omkostninger forsvinder ikke med kunden, så resultatet rammes hårdere end omsætningen.',
  'adv.sales.scn.riskText.growRecurring': 'Tilbagevendende aftaler binder dig til pris og levering over tid.',
  'adv.sales.scn.scopeText.all': 'Alle produkter og tjenester',
  'adv.sales.scn.scopeText.discounted': 'Kun fakturaer med rabat',
  'adv.sales.scn.scopeText.topCustomer': 'Kun største kunde',
  'adv.sales.scn.scopeText.recurring': 'Kun tilbagevendende salg',
  'adv.sales.closerTag': 'Det ville jeg have gjort',
  'adv.tab.tax': 'Skat',
  'adv.tab.budget': 'Budget',
  'adv.tab.insight': 'Indsigt',
  'adv.plan.title': 'Budget mod faktisk',
  'adv.plan.sub': '{year} — bogført indtil nu mod budgettet for de første {months} måneder',
  'adv.plan.help': 'Bogførte tal er år til dato, mens budgettet gælder hele året. Jeg sammenligner derfor med budgettet til og med den aktuelle måned — ellers ville alt se ud til at ligge langt under budget i januar.',
  'adv.plan.tableTitle': 'Afvigelse pr. kategori',
  'adv.plan.tableSub': 'Budget for de første {months} måneder mod bogført',
  'adv.plan.tableHelp': 'Rækkerne er sorteret efter afvigelsens størrelse. Konti, der er bogført på uden at være budgetteret, vises også — de er ofte de mest interessante.',
  'adv.plan.col.category': 'Kategori',
  'adv.plan.col.budget': 'Budget til dato',
  'adv.plan.col.actual': 'Bogført',
  'adv.plan.col.variance': 'Afvigelse',
  'adv.plan.unbudgeted': 'Ikke budgetteret',
  'adv.plan.incomeVariance': 'Indtægtsafvigelse',
  'adv.plan.costVariance': 'Omkostningsafvigelse',
  'adv.plan.abovePlan': 'over plan',
  'adv.plan.belowPlan': 'under plan',
  'adv.plan.overPlan': 'over plan',
  'adv.plan.underPlan': 'under plan',
  'adv.plan.separateNote': 'Indtægts- og omkostningsafvigelsen vises hver for sig. Lægges de sammen, kan et tab på indtægten og en besparelse på omkostningen udligne hinanden og se ud, som om alt går efter planen.',
  'adv.plan.noteWorse': '{name} afviger {amount} i den forkerte retning efter {months} måneder. Værd at se på, før afvigelsen vokser resten af året.',
  'adv.plan.noteBetter': '{name} ligger {amount} bedre end budgetteret efter {months} måneder.',
  'adv.plan.noteUnbudgeted': 'Der er bogført {amount} på {name}, uden at kontoen er budgetteret.',
  'adv.plan.editBudget': 'Ændr budgettet',
  'adv.plan.noBudgetTitle': 'Intet budget for dette år',
  'adv.plan.noBudgetText': 'Uden et budget har jeg intet at måle de bogførte tal mod. Lægger du et ind, viser jeg afvigelser pr. kategori og siger til, når noget trækker væk fra planen.',
  'adv.plan.goToBudget': 'Lav budget',
  'adv.plan.notStartedTitle': 'Året er ikke begyndt endnu',
  'adv.plan.notStartedText': 'Der er ingen bogførte måneder i {year} at sammenligne budgettet med.',
  'adv.plan.goalsTitle': 'Mål',
  'adv.plan.goalsSub': 'Dine egne mål, målt mod bogførte tal',
  'adv.plan.goalsHelp': 'Målet vises fra det år, du opretter det for, og frem, indtil du markerer det som gennemført. Et mål med overskredet frist bliver stående, indtil du vurderer det igen. Indtægt, resultat og margin måles for hvert regnskabsår, mens buffer følger saldoen.',
  'adv.plan.goalsEmptyTitle': 'Ingen mål sat endnu',
  'adv.plan.goalsEmptyText': 'Sæt et mål med en frist — for eksempel en kontantbuffer eller en resultatmargin — så følger jeg fremdriften og siger til, hvis du sakker bagud.',
  'adv.plan.goalNew': 'Nyt mål',
  'adv.plan.goalEdit': 'Ændr mål',
  'adv.plan.goalSave': 'Gem mål',
  'adv.plan.goalSaved': 'Målet er gemt',
  'adv.plan.goalSaveFailed': 'Kunne ikke gemme målet',
  'adv.plan.goalDeleted': 'Målet er slettet',
  'adv.plan.goalTitleLabel': 'Hvad er målet?',
  'adv.plan.goalTitlePh': 'F.eks. Opbyg en kontantbuffer før nytår',
  'adv.plan.goalMetricLabel': 'Hvad skal måles?',
  'adv.plan.goalMetricHint': 'Den aktuelle værdi hentes fra regnskabet, ikke fra noget, du skriver ind.',
  'adv.plan.goalTargetAmount': 'Måltal (kr)',
  'adv.plan.goalTargetPct': 'Måltal (%)',
  'adv.plan.goalNow': 'Nu',
  'adv.plan.goalTarget': 'Mål',
  'adv.plan.goalDeadline': 'Frist',
  'adv.plan.goalDaysLeft': 'Dage tilbage',
  'adv.plan.goalMeasured': 'Måles mod: {metric}',
  'adv.plan.goalFromYear': 'Fra {year}',
  'adv.plan.goalReached': 'Nået',
  'adv.plan.goalCompleted': 'Gennemført',
  'adv.plan.goalNeedsReview': 'Fristen er overskredet – vurdér målet',
  'adv.plan.goalComplete': 'Markér mål som gennemført',
  'adv.plan.goalReopen': 'Genåbn mål',
  'adv.plan.goalOverdue': 'Fristen er overskredet',
  'adv.plan.goalOnTrack': 'Efter planen',
  'adv.plan.goalBehind': 'Bagud i forhold til planen',
  'adv.plan.goalTracking': 'Følger med',
  'adv.plan.metric.buffer': 'Kontantbeholdning ved årets udgang',
  'adv.plan.metric.income': 'Bogført omsætning',
  'adv.plan.metric.result': 'Bogført resultat',
  'adv.plan.metric.margin': 'Resultatmargin',
  'adv.plan.saving': 'Gemmer …',
  'adv.plan.eventsTitle': 'Planlagte hændelser',
  'adv.plan.eventsSub': 'Kendte ind- og udbetalinger, der endnu ikke er bogført',
  'adv.plan.eventsHelp': 'Hændelser vises i det år, datoen hører til. De flyttes ikke automatisk til næste år; ændr datoen, hvis betalingen er udskudt. Kun kommende, ikke-bogførte hændelser indgår i likviditetsprognosen.',
  'adv.plan.eventsEmptyTitle': 'Ingen planlagte hændelser',
  'adv.plan.eventsEmptyText': 'Uden registrerede hændelser er likviditetskurven flad efter den aktuelle måned, fordi den kun kender bogførte tal.',
  'adv.plan.eventsNote': 'Hændelser i tidligere måneder medtages ikke i kurven. Fjern en hændelse, når betalingen er bogført, så den ikke tælles to gange.',
  'adv.plan.eventNew': 'Ny hændelse',
  'adv.plan.eventEdit': 'Ændr hændelse',
  'adv.plan.eventSave': 'Gem hændelse',
  'adv.plan.eventSaved': 'Hændelsen er gemt',
  'adv.plan.eventSaveFailed': 'Kunne ikke gemme hændelsen',
  'adv.plan.eventDeleted': 'Hændelsen er slettet',
  'adv.plan.eventLabel': 'Hvad drejer det sig om?',
  'adv.plan.eventLabelPh': 'F.eks. Feriepenge til medarbejdere',
  'adv.plan.eventKind': 'Type',
  'adv.plan.eventDate': 'Dato',
  'adv.plan.eventDirection': 'Retning',
  'adv.plan.eventDirectionHint': 'Ud sænker kontantbeholdningen, ind øger den.',
  'adv.plan.directionOut': 'Ud af kontoen',
  'adv.plan.directionIn': 'Ind på kontoen',
  'adv.plan.eventAmount': 'Beløb',
  'adv.plan.kind.salary': 'Løn og bonus',
  'adv.plan.kind.tax': 'Skat og afgifter',
  'adv.plan.kind.supplier': 'Leverandørbetaling',
  'adv.plan.kind.investment': 'Investering',
  'adv.plan.kind.loan': 'Lån og afdrag',
  'adv.plan.kind.other': 'Andet',
  'adv.tab.reports': 'Rapporter',
  'adv.tab.benchmark': 'Sammenligning',
  'adv.basisCmp.title': 'Sammenligningsgrundlag',
  'adv.basisCmp.sub': 'Hvad tallene faktisk måles mod',
  'adv.basisCmp.help': 'Nøgletallene nedenfor sammenlignes ikke med andre virksomheder. To af dem måles mod virksomhedens egne tal fra året før og to mod en fast tærskel. Hver linje er markeret med, hvilken af delene det er.',
  'adv.basisCmp.year': 'Regnskabsår',
  'adv.basisCmp.against': 'Sammenlignet med',
  'adv.basisCmp.againstValue': 'Egne tal fra {year}',
  'adv.basisCmp.source': 'Datakilde',
  'adv.basisCmp.sourceValue': 'Bogførte tal i Plumme',
  'adv.basisCmp.industry': 'Branchedata',
  'adv.basisCmp.industryValue': 'Ikke tilgængelig',
  'adv.basisCmp.row.previousYear': 'mod {year}',
  'adv.basisCmp.row.threshold': 'mod fast tærskel',
  'adv.hero.tag': 'SuperPlummas indsigt denne måned',
  'adv.hero.empty': 'AI Rådgiver har brug for bogførte indtægter, omkostninger og åbne poster, før den kan give konkrete råd.',
  'adv.hero.freeCapital': 'Ledig kapital',
  'adv.hero.notCalculated': 'ikke beregnet',
  'adv.hero.healthScore': 'Sundhedsscore',
  'adv.hero.waiting': 'venter',
  'adv.hero.ask': 'Spørg SuperPlumma',
  'adv.hero.chatTitle': 'Chat med SuperPlumma',
  'adv.hero.chatHint': 'Chat med mig',
  'adv.hero.briefTag': 'Månedsindsigt fra SuperPlumma · {year}',
  'adv.hero.healthLead': 'Økonomisk sundhed:',
  'adv.hero.greeting.morning': 'Godmorgen.',
  'adv.hero.greeting.day': 'Hej.',
  'adv.hero.greeting.evening': 'God aften.',
  'adv.hero.greetingNamed.morning': 'Godmorgen, {name}.',
  'adv.hero.greetingNamed.day': 'Hej, {name}.',
  'adv.hero.greetingNamed.evening': 'God aften, {name}.',
  'adv.hero.tasksToday': '{count} ting at gøre i dag',
  'adv.hero.seeAnalysis': 'Se analyse',
  'adv.hero.effectNote.earlierIn': 'tidligere ind',
  'adv.hero.effectNote.overduePayables': 'forfaldent til leverandør',
  'adv.hero.effectNote.vatToCover': 'skal dækkes',
  'adv.hero.effectNote.vouchersAtRisk': 'køb uden bilag',
  'adv.overnight.title': 'SuperPlumma har gennemgået',
  'adv.overnight.transactions': '{count} transaktioner analyseret',
  'adv.overnight.vouchers': '{count} bilag kontrolleret',
  'adv.overnight.risks': '{count} risici vurderet',
  'adv.overnight.recommendations': '{count} anbefalinger fundet',
  'adv.overnight.updated': 'Sidst opdateret {time}',
  'adv.analysis.title': 'Åben AI-analyse af regnskabet',
  'adv.analysis.empty': 'Analysen er ikke tilgængelig lige nu.',
  'adv.feed.title': 'SuperPlumma holdt øje',
  'adv.feed.sub': 'Det, jeg har bemærket på det seneste',
  'adv.feed.help': 'Ændringer, jeg har opdaget i regnskabet — ikke anbefalinger. Rød haster, gul bør følges op, grøn er kun til orientering.',
  'adv.feed.seeDetails': 'Se detaljer',
  'adv.feed.marginDown.title': 'Overskudsgraden er faldet {points} procentpoint',
  'adv.feed.marginDown.body': 'Målt mod sidste år. Værd at se nærmere på, før det bliver en trend.',
  'adv.feed.marginUp.title': 'Overskudsgraden er steget {points} procentpoint',
  'adv.feed.marginUp.body': 'Målt mod sidste år. Ingen handling nødvendig — bare rart at vide.',
  'adv.feed.costLineJump.title': '{name} er steget {pct} %',
  'adv.feed.costLineJump.body': 'Omkostningsposten vokser hurtigere end resten i forhold til sidste år.',
  'adv.feed.overdueSales.title': '{amount} i tilgodehavender fra kunder er forfaldent',
  'adv.feed.overdueSales.body': 'Pengene er allerede tjent — de mangler bare at komme ind.',
  'adv.feed.overduePurchases.title': '{amount} i leverandørkrav er forfaldent',
  'adv.feed.overduePurchases.body': 'Forfaldne leverandørkrav kan give morarenter og rykkergebyr.',
  'adv.feed.concentration.title': 'Én kunde står for {pct} % af salget',
  'adv.feed.concentration.body': 'Stor kundeafhængighed gør omsætningen sårbar, hvis kunden falder fra.',
  'adv.feed.costsDown.title': 'Omkostningerne er faldet {pct} % i forhold til sidste år',
  'adv.feed.costsDown.body': 'Ingen handling nødvendig — bare rart at vide.',
  'adv.feed.incomeUp.title': 'Omsætningen er steget {pct} % i forhold til sidste år',
  'adv.feed.incomeUp.body': 'Væksten er beregnet ud fra bogførte indtægter i samme periode.',
  'adv.feed.vouchersComplete.title': 'Alle køb har bilag',
  'adv.feed.vouchersComplete.body': 'Intet her kræver din opmærksomhed lige nu.',
  'adv.employees.title': 'Medarbejdere & løn',
  'adv.employees.help': 'Modulet vises kun, fordi virksomheden har medarbejdere eller lønkørsler. Tallene er hentet fra bogførte lønomkostninger og dine lønkørsler.',
  'adv.employees.count': 'Medarbejdere',
  'adv.employees.share': 'Lønomkostning / omsætning',
  'adv.employees.cost': 'Bogført lønomkostning',
  'adv.employees.runs': 'Lønkørsler i år',
  'adv.employees.note': 'Lønandelen er beregnet ud fra bogførte konti i 5000-serien mod årets omsætning.',
  'adv.employees.go': 'Se løn',
  'adv.taskcenter.title': 'Mine opgaver fra SuperPlumma',
  'adv.taskcenter.all': 'Alle',
  'adv.taskcenter.empty': 'Ingen opgaver i denne kategori.',
  'adv.status.bucket.now': 'Kræver handling nu',
  'adv.profile.title': 'Rådgiverprofil',
  'adv.profile.help': 'Alt, hvad SuperPlumma ved om, hvordan du vil have råd — buffer, mål, risikoniveau og hyppighed — samlet ét sted. Du kan ændre det hele her.',
  'adv.profile.intro': 'Dette bruger jeg til at gøre rådene mere præcise. Ændrer du noget her, ændrer det, hvordan jeg prioriterer — ikke hvordan regnskabet føres.',
  'adv.profile.buffer': 'Ønsket buffer',
  'adv.profile.mainGoal': 'Vigtigste mål',
  'adv.profile.mainGoal.revenue': 'Øge omsætningen',
  'adv.profile.mainGoal.profitability': 'Øge rentabiliteten',
  'adv.profile.mainGoal.buffer': 'Opbygge kontantbuffer',
  'adv.profile.mainGoal.hiring': 'Ansætte',
  'adv.profile.mainGoal.investment': 'Investere',
  'adv.profile.mainGoal.workload': 'Reducere arbejdspresset',
  'adv.profile.mainGoal.dividend': 'Gøre virksomheden klar til udbytte',
  'adv.profile.risk': 'Foretrukket risikoniveau',
  'adv.profile.risk.cautious': 'Tryg og forsigtig',
  'adv.profile.risk.balanced': 'Balanceret',
  'adv.profile.risk.offensive': 'Åben for risiko',
  'adv.profile.cadence': 'Hvor ofte du ønsker råd',
  'adv.profile.cadence.daily': 'Dagligt',
  'adv.profile.cadence.weekly': 'Ugentligt',
  'adv.profile.cadence.monthly': 'Månedligt',
  'adv.profile.accountantInvolved': 'Bogholderen skal involveres i forslag, der kræver vurdering',
  'adv.profile.investments': 'Planlagte hændelser',
  'adv.profile.noInvestments': 'Ingen registreret',
  'adv.profile.season': 'Sæsonmønster',
  'adv.profile.seasonText': 'Stærke måneder: {strong}. Svage måneder: {weak}.',
  'adv.profile.noSeason': 'For lidt bogført til at se et mønster endnu.',
  'adv.profile.learned': 'Hvad jeg har lært af dine valg',
  'adv.profile.nothingLearned': 'Intet lært endnu.',
  'adv.profile.saveFailed': 'Kunne ikke gemme rådgiverprofilen',
  'adv.buffer.recommended': 'Anbefalet buffer',
  'adv.buffer.chosen': 'Valgt buffer',
  'adv.buffer.edit': 'Justér likviditetsbuffer',
  'adv.buffer.editAria': 'Justér likviditetsbuffer på {amount}',
  'adv.buffer.title': 'Likviditetsbuffer',
  'adv.buffer.auto': 'Automatisk anbefaling',
  'adv.buffer.autoHelp': 'SuperPlumma bruger det højeste beregnede behov. Lige nu er anbefalingen {amount}.',
  'adv.buffer.custom': 'Brugerdefineret beløb',
  'adv.buffer.customHelp': 'Brug dette beløb som fast grænse i råd, risiko og pengestrøm.',
  'adv.buffer.amount': 'Ønsket buffer i kroner',
  'adv.buffer.basisTitle': 'Grundlag for automatisk anbefaling',
  'adv.buffer.basisMinimum': 'Minimumsniveau',
  'adv.buffer.basisMonthlyCosts': 'Én måneds omkostninger',
  'adv.buffer.basisTax': 'Beregnet skattereserve',
  'adv.buffer.basisVat': 'Kommende moms',
  'adv.buffer.basisHelp': 'Automatisk buffer bruger det højeste af disse beløb. Dette er en styringsgrænse, ikke penge, der står på en separat konto.',
  'adv.buffer.saving': 'Gemmer …',
  'adv.buffer.saved': 'Likviditetsbuffer gemt',
  'adv.buffer.invalid': 'Indtast et beløb større end 0 kr.',
  'adv.buffer.unavailable': 'Bufferindstillingen er ikke tilgængelig lige nu.',
  'adv.buffer.saveFailed': 'Kunne ikke gemme likviditetsbufferen.',
  'adv.generated.kicker': 'Åben AI-analyse af regnskabet',
  'adv.generated.daily': 'Dagens råd',
  'adv.generated.monthly': 'Denne måned',
  'adv.generated.previousMonthly': 'Forrige måned',
  'adv.generated.loading': 'SuperPlumma læser det opdaterede rådgivningsgrundlag …',
  'adv.generated.updated': 'Opdateret {date}',
  'adv.generated.topOpportunity': 'Din største mulighed',
  'adv.generated.changes': 'Hvad sker der lige nu?',
  'adv.generated.actions': 'Det her ville jeg gøre nu',
  'adv.generated.opportunities': 'Muligheder',
  'adv.generated.taxChecks': 'Skat og moms – kontrolpunkter',
  'adv.generated.more': 'Se flere muligheder og kontrolpunkter',
  'adv.generated.nextStep': 'Næste trin',
  'adv.generated.readOnly': 'Analysen er kun vejledende og udfører ingen handlinger.',
  'adv.generated.importCoverage': 'Baseret på importerede summer og reskontro. Kontrol af enkelte posteringer og bilagenes fuldstændighed er begrænset.',
  'adv.generated.refresh': 'Opdater råd',
  'adv.generated.failed': 'Kunne ikke opdatere AI-rådet nu.',
  'adv.generated.unavailable': 'Ingen AI-råd er klar endnu',
  'adv.generated.empty': 'Der er endnu ingen færdige råd at vise. Prøv at opdatere rådene.',
  'adv.generated.limitReached': 'Månedsgrænsen for nye AI-råd er nået. Eksisterende råd er stadig tilgængelige, og grænsen nulstilles næste måned.',
  'adv.generated.todayCurrent': 'Dagens råd er klar',
  'adv.generated.monthCurrent': 'Månedsrådet er opdateret i dag',
  'adv.generated.previousMonthCurrent': 'Tilbageblikket er opdateret i dag',
  'adv.generated.noDataChanges': 'Ingen nye data',
  'adv.generated.monthCooldown': 'Opdateres ugentligt',
  'adv.generated.todayAlreadyCurrent': 'Dagens råd er allerede tilgængeligt. Du får et nyt dagsråd tidligst næste dag.',
  'adv.generated.monthAlreadyCurrent': 'Månedsrådet er opdateret i dag. Det kan opdateres igen i morgen, hvis regnskabsgrundlaget ændrer sig.',
  'adv.generated.previousMonthAlreadyCurrent': 'Tilbageblikket er opdateret i dag. Det kan opdateres igen i morgen, hvis der bogføres nye data i perioden.',
  'adv.generated.noDataChangesInfo': 'Ingen nye regnskabsdata siden forrige råd. Der blev ikke brugt noget AI-kald.',
  'adv.generated.monthCooldownInfo': 'Månedsrådet kan opdateres én gang om ugen, når regnskabsgrundlaget har ændret sig.',
  'adv.generated.previousKept': 'Det forrige råd bliver stående.',
  'adv.generated.type.booked': 'Bogført faktum',
  'adv.generated.type.calculated': 'Beregnet',
  'adv.generated.type.scenario': 'Scenarie',
  'adv.generated.type.opportunity': 'Mulighed',
  'adv.generated.type.control': 'Kontrolpunkt',
  'adv.generated.confidence.high': 'Godt grundlag',
  'adv.generated.confidence.medium': 'Middel grundlag',
  'adv.generated.confidence.low': 'Tyndt grundlag',
  'adv.health.title': 'Økonomisk sundhedsscore',
  'adv.health.sub': 'Samlet vurdering af virksomhedens finansielle tilstand',
  'adv.health.help': 'Den samlede score vises kun, når alle fire nøgletal kan beregnes. Ukendte værdier giver ingen point. Se datagrundlaget for, hvad der mangler.',
  'adv.health.badge.good': 'Sund',
  'adv.health.badge.stable': 'Stabil',
  'adv.health.badge.weak': 'Svag',
  'adv.health.badge.none': 'Ikke nok data',
  'adv.health.word.good': 'God økonomisk sundhed',
  'adv.health.word.stable': 'Stabil økonomi',
  'adv.health.word.weak': 'Kræver opfølgning',
  'adv.health.word.none': 'Foreløbig vurdering',
  'adv.health.emptyTitle': 'Ikke nok data til sundhedsscore',
  'adv.health.emptyText': 'Bogfør salg, køb og åbne poster for at aktivere analysen.',
  'adv.health.summaryFallback': 'SuperPlumma vurderer likviditet, vækst, rentabilitet og stabilitet ud fra dit regnskab.',
  'vat.wordMva': 'moms',
  'vat.wordMoms': 'moms',
  'vat.exemptMva': 'Uden for MVA-loven',
  'vat.exemptMoms': 'Uden for moms',
  'vat.rateLabel': '{{rate}} % {{word}}',
  'vat.zeroRated': '0 % {{suffix}}',
  'vat.zeroRatedSuffixMva': 'fritaget',
  'vat.zeroRatedSuffixMoms': 'momsfrit',
  'vat.salesReverseCharge51': '51 - Omvendt betalingspligt ved salg',
  'vat.export52': '52 - Eksport/udførsel',
  'adv.health.category.likviditet': 'Likviditet',
  'adv.health.category.vekst': 'Vækst',
  'adv.health.category.lonnsomhet': 'Rentabilitet',
  'adv.health.category.stabilitet': 'Stabilitet',
  'adv.health.note.noOpenPayables': 'Ingen åbne leverandørkrav registreret',
  'adv.health.note.noDebt': 'Ingen gæld',
  'adv.health.note.unknown': 'Ukendt',
  'adv.health.note.receivablesVsPayables': 'Tilgodehavender fra salg målt mod åbne leverandørkrav',
  'adv.health.note.zeroPrevYearRevenue': 'Sidste års omsætning er 0; procentvis vækst kan ikke beregnes',
  'adv.health.note.needsPrevYear': 'Kræver tal fra sidste år til sammenligning',
  'adv.health.note.revenueChangeVsPrevYear': 'Omsætningsændring i forhold til samme år sidste år',
  'adv.health.note.marginFromReport': 'Resultatmargin fra resultatrapporten',
  'adv.health.note.noBookedRevenue': 'Ingen bogført omsætning i det valgte år',
  'adv.health.note.largestCustomerShare': 'Andel af salg fra største kunde',
  'adv.health.note.needsInvoicesPerCustomer': 'Kræver fakturasalg pr. kunde',
  'adv.help.healthCard': 'Sundhedsscoren er en enkel samlet sum fra 0 til 100. Den ser på flere ting på én gang, som penge på kontoen, indtægter, omkostninger og risiko. Det er en pejling, ikke en dom.',
  'adv.help.liquidity': 'Dette beløb er åbne tilgodehavender fra salg minus åbne leverandørkrav. Det viser ikke, hvor mange penge der står på bankkontoen.',
  'adv.help.expectedBalance': 'Beregnet plansaldo ved periodens udgang. Tallene bygger ikke på afstemt banksaldo eller sikre betalingsdatoer.',
  'adv.help.expectedIn': 'Bogførte indtægter i det viste vindue, ikke bekræftede indbetalinger.',
  'adv.help.expectedOut': 'Bogførte omkostninger i det viste vindue, ikke bekræftede udbetalinger.',
  'adv.help.cashBalance': 'Saldo er de penge, der er tilgængelige lige nu i beregningen.',
  'adv.help.bookedIn': 'Bogført ind er indtægter eller indbetalinger, der allerede ligger i regnskabet for perioden.',
  'adv.help.bookedOut': 'Bogført ud er omkostninger eller udbetalinger, der allerede ligger i regnskabet for perioden.',
  'adv.help.endBalance': 'Slutsaldo er saldoen i dag plus penge ind minus penge ud. Den viser, hvor kassebeholdningen ender i denne beregning.',
  'adv.help.buffer': 'Likviditetsbuffer er en ønsket sikkerhedsgrænse. Det er ikke en separat konto, men et beløb, Plumme bruger til at advare, når kassebeholdningen bliver for lav.',
  'adv.help.bufferMinimum': 'Minimumsniveau er Plummes laveste anbefalede buffer. Det forhindrer, at anbefalingen bliver alt for lav, når virksomheden har lidt historik.',
  'adv.help.monthlyCosts': 'Én måneds omkostninger betyder cirka, hvad virksomheden normalt bruger på en måned. Det hjælper dig med at klare en sløv måned.',
  'adv.help.taxReserve': 'Skattereserve er penge, du bør sætte til side til skat, så skatteregningen ikke kommer som en overraskelse.',
  'adv.help.vatDue': 'Kommende moms er merværdiafgift, der ser ud til at skulle betales ved næste momsfrist.',
});
